import z from 'zod';

export const BulkActionNameSchema = z.enum([
  'activate',
  'deactivate',
  'send_invitation',
  'change_role',
  'remove',
]);

export const BulkTaskStatusValueSchema = z.enum([
  'pending',
  'in_progress',
  'completed',
  'failed',
]);

export const BulkTaskAcceptedSchema = z.object({
  taskId: z.string(),
  status: BulkTaskStatusValueSchema,
});

export const BulkTaskFailureSchema = z.object({
  userId: z.number(),
  reason: z.string(),
});

export const BulkTaskStatusSchema = z.object({
  status: BulkTaskStatusValueSchema,
  action: BulkActionNameSchema,
  total: z.number(),
  processed: z.number(),
  succeeded: z.array(z.number()),
  failed: z.array(BulkTaskFailureSchema),
  skipped: z.array(z.number()),
});

export type BulkActionName = z.infer<typeof BulkActionNameSchema>;
export type BulkTaskStatusValue = z.infer<typeof BulkTaskStatusValueSchema>;
export type BulkTaskAccepted = z.infer<typeof BulkTaskAcceptedSchema>;
export type BulkTaskFailure = z.infer<typeof BulkTaskFailureSchema>;
export type BulkTaskStatus = z.infer<typeof BulkTaskStatusSchema>;
